import { render, staticRenderFns } from "./ChangeNotesPopup.vue?vue&type=template&id=920ef4f4&scoped=true"
import script from "./ChangeNotesPopup.vue?vue&type=script&lang=js"
export * from "./ChangeNotesPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeNotesPopup.vue?vue&type=style&index=0&id=920ef4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920ef4f4",
  null
  
)

export default component.exports